export default __webpack_public_path__ + "static/media/notice-close-icon.ccc3e716.svg";